import './BeginOverview.scss';
import 'primeflex/primeflex.scss';
import React from 'react';
import Card from 'components/chrome/Card';
import Sitemap from 'components/app/Sitemap'
import { Button } from 'primereact/button';
import { NavLink } from 'react-router-dom';
import img030 from 'img/icons/030-news.svg';
import img027 from 'img/icons/027-cloud-storage-1.svg';
import img048 from 'img/icons/048-folder-3.svg';
import img049 from 'img/icons/049-sharing.svg';


class BeginOverview extends React.Component {

  constructor() {
    super();
    this.sitemap = new Sitemap.Factory().create();
  }

  render() {
    return (
      <div className='BeginOverview'>
        <div className='section'>
          <div className='subtitle'>Overview</div>
          <p>
            Let's get started! You have no configurations set up yet. From here, we'll get an understanding of your devices, what type of data they collect, and how they send it to the cloud.
          </p>
        </div>
        <div className='section'>
          <div className='p-grid'>
            <div className='p-col-6'>
              <Card
                  className='overviewCard'
                  header='Configure data types'
                  text='Describe the data and metadata your devices are collecting.'
                  img={img030}
                  imgClassName='cardImage1'
                  imgPadded
                  />
            </div>
            <div className='p-col-6'>
              <Card
                  className='overviewCard'
                  header='Generate custom API'
                  text='Once you commit your configuration, a virtual private API is tailored to your devices.'
                  img={img049}
                  imgClassName='cardImage2'
                  imgPadded
                  />
            </div>
            <div className='p-col-6'>
              <Card
                  className='overviewCard'
                  header='Integration options'
                  text='With a fresh environment set up, you can connect via iOS, Android, hub or web.'
                  img={img027}
                  imgClassName='cardImage3'
                  imgPadded
                  />
            </div>
            <div className='p-col-6'>
              <Card 
                  className='overviewCard'
                  header='Launch it!'
                  text='Read about our cybersecurity and regulatory best practices, and sleep easy.'
                  img={img048}
                  imgClassName='cardImage4'
                  imgPadded
                  />
            </div>
          </div>
        </div>
        <div className='section right'>
          <NavLink to={this.sitemap.getNextUrl()}>
            <Button icon='pi pi-chevron-right' iconPos='right' label='Continue' />
          </NavLink>
        </div>
      </div>
    );
  }
}


export default BeginOverview;
